export const enum VoucherType {
  Absolute = 'VoucherAbsolute',
  Relative = 'VoucherRelative',
  FreeShipping = 'VoucherFreeShipping',
  CascadingAbsolute = 'VoucherCascadingAbsolute',
  CascadingRelative = 'VoucherCascadingRelative',
  WithoutVoucher = 'WithoutVoucher',
}
